import { render, staticRenderFns } from "./SortDetails.vue?vue&type=template&id=82e76c06&"
import script from "./SortDetails.vue?vue&type=script&lang=js&"
export * from "./SortDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports